import {
  startOfYesterday, subMonths, startOfMonth, lastDayOfMonth, startOfToday, startOfTomorrow,
  subDays,
} from 'date-fns';
import { DatePickerDefaultRanges } from '../constants';

export const getDefaultDateRangeMap = ({ getTranslation, initialRangesRef }) => {
  const todayDate = startOfToday();
  const yesterdayDate = startOfYesterday();
  const tomorrowStartDate = startOfTomorrow();
  const currMonthStartDate = startOfMonth(todayDate);
  const currMonthLastDate = lastDayOfMonth(todayDate);
  const lastThirtyDay = subDays(tomorrowStartDate, 30);
  const lastSeventhDate = subDays(tomorrowStartDate, 7);
  const firstDayOfPrevMonth = subMonths(currMonthStartDate, 1);
  const lastDayOfPrevMonth = lastDayOfMonth(firstDayOfPrevMonth);

  const defaultRangeDateMap = {
    [DatePickerDefaultRanges.last30Days]: {
      label: getTranslation('DTP_LAST_30_DAYS'),
      range: [lastThirtyDay, todayDate],
    },
    [DatePickerDefaultRanges.last7Days]: {
      label: getTranslation('DTP_LAST_7_DAYS'),
      range: [lastSeventhDate, todayDate],
    },
    [DatePickerDefaultRanges.TODAY]: {
      label: getTranslation('DTP_TODAY'),
      range: [todayDate, todayDate],
    },
    [DatePickerDefaultRanges.YESTERDAY]: {
      label: getTranslation('DTP_YESTERDAY'),
      range: [yesterdayDate, yesterdayDate],
    },
    [DatePickerDefaultRanges.LAST_MONTH]: {
      label: getTranslation('DTP_LAST_MONTH'),
      range: [firstDayOfPrevMonth, lastDayOfPrevMonth],
    },
    [DatePickerDefaultRanges.THIS_MONTH]: {
      label: getTranslation('DTP_THIS_MONTH'),
      range: [currMonthStartDate, currMonthLastDate],
    },
    [DatePickerDefaultRanges.ALL]: {
      label: getTranslation('DTP_ALL_TIME'),
      range: initialRangesRef?.current || [],
    },
    [DatePickerDefaultRanges.CUSTOM]: {
      label: getTranslation('DTP_CUSTOM'),
      range: [todayDate, todayDate],
    },
  };

  return defaultRangeDateMap;
};
